import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Helpers } from '../../helpers/Helpers';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import TableFooter from '../../components/TableFooter';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import ExcelExportMenu from '../../components/ExcelExportMenu';
import TableConstantActions from '../../components/TableConstantActions';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { buildExcelRequest, ExcelExportMode } from '../../helpers/excelExportRequest';
import { personelUcretYetkisi } from '../../services/PersonelUcretService';
import {
    CikisDuzeltIstegi, ElleEkleIstegi, GUN_TIPLERI, IS_TIPLERI, initialMesaiKaydiListIstegi, KAPANIS_NEDENLERI, MESAI_DURUMLARI, MESAI_KAYNAKLARI, MESAI_TURLERI,
    MesaiKaydiItem, MesaiKaydiListIstegi, MesaiKaydiListSonucu, MesaiKaydiService, ondalikSaat, saatDakika, trTarih
} from '../../services/MesaiKaydiService';
import { googleHaritaBaglantisi, mesafeMetni } from '../../helpers/haritaBaglantisi';
import { QR_RENKLERI } from '../../components/QrEtiket/noktaEtiketleri';
import ElleEkleModal from './Components/ElleEkleModal';
import CikisDuzeltModal from './Components/CikisDuzeltModal';

const secenekler = (l: { value: number, label: string }[]) => () => Promise.resolve(l.map(x => ({ value: String(x.value), label: x.label })));

const HAVUZ_DURUMLARI = [
    { value: 'BEKLIYOR', label: 'Havuzda' },
    { value: 'YENIDEN', label: 'Yeniden ata' },
    { value: 'ATANDI', label: 'Atandı' },
];

/** Durum rozeti: Açık / Tamam / Eksik çıkış / Düzeltildi · kim. */
const DurumRozeti = ({ item }: { item: MesaiKaydiItem }) => {
    if (item.durum == 3)
        return <span className='badge badge-light-danger ebbe-status-badge'>Eksik çıkış</span>;

    if (item.durum == 1)
        return <span className='badge badge-light-primary ebbe-status-badge'>Açık</span>;

    if (item.duzeltenAdi)
        return <span className='badge badge-light-warning ebbe-status-badge' title={item.duzeltmeZamani ?? undefined}>Düzeltildi · {item.duzeltenAdi}</span>;

    return <span className='badge badge-light-success ebbe-status-badge'>{item.durumAdi || 'Tamam'}</span>;
}

/** İş tipi rozeti: QR çerçeve rengiyle aynı (Lojistik mavi, Ambalaj turuncu). */
const IsTipiRozeti = ({ item }: { item: MesaiKaydiItem }) => {
    if (!item.isTipiAdi)
        return null;

    var renk = item.isTipi == 2 ? QR_RENKLERI.ambalaj : QR_RENKLERI.lojistik;

    return <span className='badge ebbe-status-badge' style={{ background: renk + '1f', color: renk }}>{item.isTipiAdi}</span>;
}

/** Kapanış nedeni rozeti: Aynı QR gri, Başka QR mor, Elle düzeltme sarı, Eksik çıkış kırmızı. */
const KapanisRozeti = ({ item }: { item: MesaiKaydiItem }) => {
    var ad = item.kapanisNedeniAdi || KAPANIS_NEDENLERI.find(x => x.value == item.kapanisNedeni)?.label;

    if (!ad)
        return null;

    var sinif = item.kapanisNedeni == 2 ? 'badge-light-info' : item.kapanisNedeni == 3 ? 'badge-light-warning' : item.kapanisNedeni == 4 ? 'badge-light-danger' : 'badge-light';

    return <span className={'badge ebbe-status-badge ' + sinif}>{ad}</span>;
}

/**
 * Konum hücresi: uzaklık + "Haritada gör" (Google Haritalar, yeni sekme). Araçta çap kontrolü olmadığı için "çap yok".
 * Giriş konumu yoksa çıkış konumu açılır.
 */
const KonumHucresi = ({ item }: { item: MesaiKaydiItem }) => {
    var arac = item.noktaTuru == 'Araç' || (item.tur == 2 && !item.noktaTuru);
    var giris = googleHaritaBaglantisi(item.girisLat, item.girisLon);
    var cikis = googleHaritaBaglantisi(item.cikisLat, item.cikisLon);
    var mesafe = [mesafeMetni(item.girisMesafe), mesafeMetni(item.cikisMesafe)].filter(x => x);

    const baglanti = (href: string, metin: string) => (
        <a href={href} target='_blank' rel='noopener noreferrer' className='fs-7 me-2 text-nowrap' onClick={(e) => e.stopPropagation()}>
            <i className='fa fa-map-marker-alt me-1' />{metin}
        </a>
    );

    return (
        <span className='text-nowrap'>
            {
                arac
                    ? <span className='badge badge-light ebbe-status-badge me-2'>{giris || cikis ? 'Alındı · çap yok' : 'Konum yok · çap yok'}</span>
                    : mesafe.length > 0 && <span className='badge badge-light-success ebbe-status-badge me-2' title='Giriş · çıkış anında QR noktasına uzaklık'>{mesafe.join(' · ')}</span>
            }
            {giris && baglanti(giris, 'Haritada gör')}
            {cikis && cikis != giris && baglanti(cikis, giris ? 'Çıkış' : 'Haritada gör')}
        </span>
    );
}

/**
 * Mesai Kayıtları (İnsan Kaynakları > Mesai Kayıtları, QR Mesai Faz 1b, 11.10.2026; standart liste ekranı).
 * Faz 2 (18.10.2026): iş tipi rozeti, kapanış nedeni, konum + Haritada gör, talep ve faturalanan aralık kolonları.
 * Tarih aralığı varsayılan bu ay. Elle Ekle, seçili satırda Çıkışı düzelt, Sil.
 * Personel ücreti yalnız "Personel Ücretleri" yetkisine görünür.
 */
const MesaiKaydiList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Mesai Kayıtları"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const ucretYetkisi = personelUcretYetkisi(auth.user.user?.data.authorizedMenus);

    const [data, setData] = useState<MesaiKaydiListSonucu>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<MesaiKaydiListIstegi>(initialMesaiKaydiListIstegi())
    const [elleEkleAcik, setElleEkleAcik] = useState(false);
    const [duzeltilen, setDuzeltilen] = useState<MesaiKaydiItem | undefined>(undefined);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Tarih', name: 'tarih', order: 0, isVisible: true },
            { title: 'Kişi', name: 'kisiAdi', order: 0, isVisible: true },
            { title: 'Tür', name: 'turAdi', order: 0, isVisible: true },
            { title: 'Nokta / Araç', name: 'noktaAdi', order: 0, isVisible: true },
            { title: 'İş Tipi', name: 'isTipiAdi', order: 0, isVisible: true },
            { title: 'Giriş', name: 'girisSaati', order: 0, isVisible: true },
            { title: 'Çıkış', name: 'cikisSaati', order: 0, isVisible: true },
            { title: 'Kapanış Nedeni', name: 'kapanisNedeniAdi', order: 0, isVisible: true },
            { title: 'Konum', name: 'konum', order: 0, isVisible: true },
            { title: 'Gün Tipi', name: 'gunTipiAdi', order: 0, isVisible: true },
            { title: 'Normal', name: 'normalDk', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Ek Mesai', name: 'ekDk', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Süre', name: 'sureDk', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Sipariş Saati', name: 'siparisDk', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Müşteri Tutarı', name: 'musteriTutari', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Durum', name: 'durumAdi', order: 0, isVisible: true },
            { title: 'Talep', name: 'talepEtiketi', order: 0, isVisible: true },
            { title: 'Faturalanan Aralık', name: 'faturaAraligi', order: 0, isVisible: true },
            { title: 'Sipariş', name: 'siparisler', order: 0, isVisible: true },
            { title: 'Havuz', name: 'havuzDurumu', order: 0, isVisible: true },
            { title: 'Kaynak', name: 'kaynakAdi', order: 0, isVisible: false },
            { title: 'Giriş Mesafesi (m)', name: 'girisMesafe', order: 0, isVisible: false, className: 'custom-text-right' },
            { title: 'Çıkış Mesafesi (m)', name: 'cikisMesafe', order: 0, isVisible: false, className: 'custom-text-right' },
        ];

        // Ücret hassas veridir: kolon yalnız yetkiliye eklenir (backend de yetkisize null döner).
        if (ucretYetkisi)
            list.splice(list.findIndex(x => x.name == 'musteriTutari'), 0, { title: 'Personel Ücreti', name: 'personelUcret', order: 0, isVisible: true, className: 'custom-text-right' });

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        var birlesik = kolonlariBirlestir(list, str);

        // Yetkisi kalkan kullanıcının kayıtlı düzeninde ücret kolonu kalmışsa gösterilmez.
        return ucretYetkisi ? birlesik : birlesik.filter(x => x.name != 'personelUcret');
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });
    }

    const changeTake = (_take: number) => {
        getData({ ...filter, currentPage: 1, skip: 0, take: _take });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: MesaiKaydiListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await MesaiKaydiService.getListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const tarihAraligiDegisti = (alan: 'baslangic' | 'bitis', deger: string) => {
        if (!deger)
            return;

        var yeni = { ...filter, [alan]: deger, currentPage: 1, skip: 0 };

        if (yeni.baslangic > yeni.bitis) {
            toast.error('Başlangıç tarihi bitişten sonra olamaz.');
            return;
        }

        getData(yeni);
    }

    const secililer = data.list.filter(x => x.isSelected);

    const setItemSelected = (_id: string) => {
        setData({ ...data, list: data.list.map(x => x.mesaiKaydiId == _id ? { ...x, isSelected: !x.isSelected } : x) })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length > 0 && data.list.length == secililer.length;

        setData({ ...data, list: data.list.map(x => ({ ...x, isSelected: !isAllSelected })) })
    }

    // ---------------------------------------------------------------- İşlemler

    const sil = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await MesaiKaydiService.sil(secililer.map(x => x.mesaiKaydiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen mesai kayıtları silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const duzeltilebilir = (x: MesaiKaydiItem | undefined) => x != undefined && (x.durum == 2 || x.durum == 3);

    const cikisiDuzeltAc = () => {
        var x = secililer[0];

        if (secililer.length != 1 || !duzeltilebilir(x)) {
            toast.error('Çıkışı düzeltmek için eksik çıkış ya da tamamlanmış tek bir kayıt seçin.');
            return;
        }

        setDuzeltilen(x);
    }

    const cikisDuzelt = async (istek: CikisDuzeltIstegi) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await MesaiKaydiService.cikisDuzelt(istek);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Çıkış saati kaydedildi; mesai yeniden hesaplandı.')

            setDuzeltilen(undefined);
            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const elleEkle = async (istek: ElleEkleIstegi) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await MesaiKaydiService.elleEkle(istek);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Mesai kaydı eklendi.')

            setElleEkleAcik(false);

            // Eklenen kayıt görünen aralığın dışındaysa aralık o güne genişletilir.
            var yeni = { ...filter, currentPage: 1, skip: 0 };

            if (istek.tarih < yeni.baslangic)
                yeni.baslangic = istek.tarih;

            if (istek.tarih > yeni.bitis)
                yeni.bitis = istek.tarih;

            getData(yeni);
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await MesaiKaydiService.exportList(buildExcelRequest(filter, mode, secililer.map(x => x.mesaiKaydiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // ---------------------------------------------------------------- Kolonlar

    // Kolon adları backend'deki FilterMap / SortMap ile aynı olmalı (MesaiKaydi liste ucu).
    const sortableColumns = [
        'tarih', 'kisiAdi', 'turAdi', 'noktaAdi', 'isTipiAdi', 'girisSaati', 'cikisSaati', 'gunTipiAdi',
        'normalDk', 'ekDk', 'sureDk', 'siparisDk', 'personelUcret', 'musteriTutari', 'durumAdi', 'havuzDurumu', 'kaynakAdi',
        'kapanisNedeniAdi', 'talepEtiketi', 'faturaAraligi'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Seçimli kolonlar sayısal değerle (tur / isTipi / gunTipi / durum / kaynak) filtrelenir; havuz metin koduyla.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        tarih: { type: 'date' },
        kisiAdi: { type: 'text' },
        turAdi: { type: 'select', allowEmpty: false, loadOptions: secenekler(MESAI_TURLERI) },
        noktaAdi: { type: 'text' },
        isTipiAdi: { type: 'select', loadOptions: secenekler(IS_TIPLERI) },
        gunTipiAdi: { type: 'select', allowEmpty: false, loadOptions: secenekler(GUN_TIPLERI) },
        normalDk: { type: 'number' },
        ekDk: { type: 'number' },
        sureDk: { type: 'number' },
        siparisDk: { type: 'number' },
        personelUcret: { type: 'number' },
        musteriTutari: { type: 'number' },
        durumAdi: { type: 'select', allowEmpty: false, loadOptions: secenekler(MESAI_DURUMLARI) },
        havuzDurumu: { type: 'select', loadOptions: () => Promise.resolve(HAVUZ_DURUMLARI) },
        kaynakAdi: { type: 'select', allowEmpty: false, loadOptions: secenekler(MESAI_KAYNAKLARI) },
        kapanisNedeniAdi: { type: 'select', loadOptions: secenekler(KAPANIS_NEDENLERI) },
        talepEtiketi: { type: 'text' },
        faturaAraligi: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const siparisLinkleri = (item: MesaiKaydiItem) => (item.siparisler ?? []).map(s =>
        <a key={s.ambarId} className='btn btn-sm btn-light-primary py-1 px-2 me-1 mb-1' onClick={(e) => { e.stopPropagation(); navigate('/ambar/listadd?id=' + s.ambarId); }}>{s.refNo}</a>
    );

    const havuzHucresi = (item: MesaiKaydiItem) => {
        if (item.havuzDurumu == 'BEKLIYOR' || item.havuzDurumu == 'YENIDEN')
            return (
                <a
                    className={'btn btn-sm py-1 px-2 ' + (item.havuzDurumu == 'YENIDEN' ? 'btn-light-danger' : 'btn-light-warning')}
                    title='Atanacak Mesailer ekranında aç'
                    onClick={(e) => { e.stopPropagation(); navigate('/mesaiatama?id=' + item.mesaiKaydiId); }}
                >
                    {item.havuzDurumu == 'YENIDEN' ? 'Yeniden ata' : 'Havuzda'}
                </a>
            );

        if (item.havuzDurumu == 'ATANDI')
            return <span className='badge badge-light-success ebbe-status-badge'>Atandı</span>;

        return null;
    }

    const getColumnValue = (item: MesaiKaydiItem, column: string, className: string | undefined) => {
        var surucu = item.tur == 2;
        var icerik: React.ReactNode;

        switch (column) {
            case 'tarih': icerik = trTarih(item.tarih); break;
            case 'kisiAdi': icerik = item.kisiAdi; break;
            case 'turAdi': icerik = <span className={'badge ebbe-status-badge ' + (surucu ? 'badge-light' : 'badge-light-info')}>{item.turAdi}</span>; break;
            case 'noktaAdi': icerik = <React.Fragment>{item.noktaAdi ?? item.aracPlaka ?? ''}{item.noktaTuru && <span className='text-muted fs-8 ms-1'>({item.noktaTuru})</span>}</React.Fragment>; break;
            case 'isTipiAdi': icerik = <IsTipiRozeti item={item} />; break;
            case 'kapanisNedeniAdi': icerik = <KapanisRozeti item={item} />; break;
            case 'konum': icerik = <KonumHucresi item={item} />; break;
            case 'talepEtiketi': icerik = item.talepEtiketi ? <span className='badge badge-light-success ebbe-status-badge'>{item.talepEtiketi}</span> : ''; break;
            case 'faturaAraligi': icerik = item.faturaAraligi ? <span title={item.faturaDk != null ? ondalikSaat(item.faturaDk) + ' saat faturalanır' : undefined}>{item.faturaAraligi}</span> : ''; break;
            case 'cikisSaati': icerik = item.cikisSaati ?? ''; break;
            case 'normalDk': icerik = surucu ? '' : saatDakika(item.normalDk); break;
            case 'ekDk': icerik = surucu ? '' : <span style={{ color: item.ekDk > 0 ? '#7239EA' : undefined }}>{saatDakika(item.ekDk)}</span>; break;
            case 'sureDk': icerik = saatDakika(item.sureDk); break;
            case 'siparisDk': icerik = surucu || item.isTipi != 1 || item.durum != 2 ? '' : ondalikSaat(item.siparisDk); break;
            case 'personelUcret': icerik = item.personelUcret == null ? '' : Helpers.correctPrice(item.personelUcret, 2); break;
            case 'musteriTutari': icerik = item.musteriTutari ? Helpers.correctPrice(item.musteriTutari, 2) : ''; break;
            case 'durumAdi': icerik = <DurumRozeti item={item} />; break;
            case 'siparisler': icerik = siparisLinkleri(item); break;
            case 'havuzDurumu': icerik = havuzHucresi(item); break;
            case 'girisMesafe': icerik = item.girisMesafe == null ? '' : Math.round(item.girisMesafe); break;
            case 'cikisMesafe': icerik = item.cikisMesafe == null ? '' : Math.round(item.cikisMesafe); break;
            default: icerik = (item as any)[column]; break;
        }

        return <td key={column} className={className} onClick={() => setItemSelected(item.mesaiKaydiId)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <div className='m-0 d-flex align-items-center'>
                    <input
                        type='date'
                        title='Başlangıç'
                        className='form-control form-control-sm form-control-solid'
                        style={{ width: 140 }}
                        value={filter.baslangic}
                        onChange={(e) => tarihAraligiDegisti('baslangic', e.target.value)}
                    />
                    <span className='mx-1 text-muted'>–</span>
                    <input
                        type='date'
                        title='Bitiş'
                        className='form-control form-control-sm form-control-solid'
                        style={{ width: 140 }}
                        value={filter.bitis}
                        onChange={(e) => tarihAraligiDegisti('bitis', e.target.value)}
                    />
                </div>

                <TableConstantActions
                    deleteFunction={sil}
                    onSearchSubmit={(e) => { e.preventDefault(); getData(); }}
                    pageName={pageName}
                    hideSearch={true}
                    searchTerm={filter.searchTerm}
                    selectedCount={secililer.length}
                    setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                />

                {
                    menu?.canUpdate && (
                        <button disabled={secililer.length != 1 || !duzeltilebilir(secililer[0])} onClick={cikisiDuzeltAc} className='btn btn-sm btn-flex btn-info' title='Seçili kaydın çıkış saatini gir / düzelt'>
                            <i className='fa fa-clock fs-6 color-gray-700 me-1' />
                            Çıkışı Düzelt
                        </button>
                    )
                }

                <ColumnChooser
                    columns={columns}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                />

                <ExcelExportMenu
                    pageName={pageName}
                    selectedCount={secililer.length}
                    onExport={excelExport}
                />

                {
                    menu?.canInsert && (
                        <div className='m-0'>
                            <a onClick={() => setElleEkleAcik(true)} className='btn btn-sm fw-bold btn-primary'>
                                Elle Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={secililer.length > 0 && secililer.length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            gorunenKolonlar.map(item =>
                                                <th key={item.name} {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={gorunenKolonlar}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map(item =>
                                            <tr key={item.mesaiKaydiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.mesaiKaydiId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {gorunenKolonlar.map(c => getColumnValue(item, c.name, c.className))}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="text-muted fs-7 py-3">
                            Normal ve ek mesai dakika ile (s:dd). Sipariş saati ek mesainin 15 dakikaya aşağı yuvarlanmışıdır; yalnız Lojistik.
                            {' '}Lojistik mesai uyan ek mesai talebine yerleşir (Talep · Faturalanan aralık); yerleşmeyen ek mesai Atanacak Mesailer'e düşer ("Havuzda"). Ambalaj, ofis ve araç mesaisi yalnız puantaja girer.
                            {' '}Başka QR okutulunca önceki kayıt o saatte kapanır ("Başka QR"). Araçta konum alınır, çap kontrolü yapılmaz. Sürücü kayıtları bilgi amaçlıdır (süre, ücret ve sipariş yok).
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={secililer.length}
                    />
                </KTCard>
            </Content>

            <ElleEkleModal isShown={elleEkleAcik} onConfirm={elleEkle} onClose={() => setElleEkleAcik(false)} />

            <CikisDuzeltModal kayit={duzeltilen} onConfirm={cikisDuzelt} onClose={() => setDuzeltilen(undefined)} />
        </React.Fragment>
    )
}

export default MesaiKaydiList;
